import { getVizierByID } from '../helpers/getVizierByID';

const VizierDisplay = (pointID) => {

    const backgroundImage = pointID.pointID === 0 ? 'url("/Empty_Background.png")' : 'url("/Tech_Background.png")' 

    return (<div className="mt-[10px] h-10 w-10" style={{ backgroundImage: backgroundImage }}>
        <img className='h-10 w-10' src={`/vizier/${getVizierByID(pointID.pointID)}`} />
    </div>)
};

export { VizierDisplay };